import { render, staticRenderFns } from "./simLogin.vue?vue&type=template&id=3bc79472&scoped=true&"
import script from "./simLogin.vue?vue&type=script&lang=js&"
export * from "./simLogin.vue?vue&type=script&lang=js&"
import style0 from "./simLogin.vue?vue&type=style&index=0&id=3bc79472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc79472",
  null
  
)

export default component.exports